import {ALookupRowsContainer} from "./lookup.rows.container";
import {SpsItemExtra} from "./sps.item.extra";

export class SpsItem extends ALookupRowsContainer {
	spsId: number; //todo
	spsItemKey: number; //todo
	procedureCodeKey: number;
	sequenceId: number;
	lateralityKey: number;
	modifierCodeKey: number;
	spsItemExtra: SpsItemExtra[];

	// public SetData(procedureCode: IProcedureCode, sequenceId: number) {
	// 	this.procedureCodeKey = procedureCode.procedureCodeKey;
	// 	this.lateralityKey =2722; // todo procedureCode.lateralityKeys;
	// 	this.sequenceId = sequenceId;
	//
	// 	this.FKLookupRows = {procedureCodeKey: procedureCode};
	// }
}
